module.exports = __webpack_public_path__ + "assets/img/tsgn7.434041e7.jpg";